import { render, staticRenderFns } from "./PersonCenterUserInfo.vue?vue&type=template&id=60a4faf6"
import script from "./PersonCenterUserInfo.vue?vue&type=script&lang=js"
export * from "./PersonCenterUserInfo.vue?vue&type=script&lang=js"
import style0 from "./PersonCenterUserInfo.vue?vue&type=style&index=0&id=60a4faf6&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports